import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppConfigurationService } from '../../app-configuration.service'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class OrganizationUsersService {
  private baseSiteUrl: string

  constructor(
    private appConfigurationService: AppConfigurationService,
    private http: HttpClient
  ) {
    this.baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
  }

  public getCurrentUser(): Observable<any> {
    return this.http.get<any>(`${this.baseSiteUrl}/orgUsers/current`)
  }
}
